import React from 'react'
import {
  PieChart,
  Pie,
  Cell,
  Label,
  Tooltip,
  ResponsiveContainer
} from 'recharts'

import { corDash as cor } from '../../../utils/dashboard'

import LabelGraficosPizzaComposto from './LabelGraficosPizzaComposto'

export default function MyPieChart({ data, valorPercentual, MyTooltip }) {
  return (
    <ResponsiveContainer height="100%" width="100%">
      <PieChart margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
        <Pie
          dataKey="value"
          data={data}
          innerRadius="60%"
          outerRadius="80%"
          fill={cor.cinzaEscuro}
          paddingAngle={0}
          stroke={0}
          isAnimationActive
          animationDuration={800}
          animationEasing="ease-out"
        >
          <Label
            content={
              <LabelGraficosPizzaComposto valorPercentual={valorPercentual} />
            }
          />
          {data.map((entry) => (
            <Cell fill={entry.cor} key={`${entry.value}-${entry.cor}`} />
          ))}
        </Pie>
        <Tooltip content={<MyTooltip />} />
      </PieChart>
    </ResponsiveContainer>
  )
}
